/**
 * Imports that used to come via Rails assets pipeline.
 *
 * We must use `require` to get the jQuery global registered before
 * loading scripts that rely on the global `jQuery` to be present
 */
require('vendorJS/modernizr');

const jQuery = require('vendorJS/jquery');
window.jQuery = jQuery;
window.$ = jQuery;

require('vendorJS/jquery_ujs');
require('jquery.cookie');
require('vendorJS/purl');

// Magellan is the last Foundation plugin still driving markup — the section
// nav on the three admin profile edit forms. The core is here to serve it.
require('foundation-sites/js/foundation/foundation');
require('foundation-sites/js/foundation/foundation.magellan');
